import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

// INTERFACES
import {
  ECustomFieldType,
  ICustomFieldValue,
} from '../../custom-field/interfaces/custom-field.interface';

@Pipe({
  name: 'customFieldParseValue',
})
export class CustomFieldParseValuePipe implements PipeTransform {
  constructor(private datePipe :DatePipe) {}

  transform(
    field :ICustomFieldValue,
    formatDate :boolean = true,
  ) :string | Date | number | null {
    if (field && field.custom_field) {
      switch (field?.custom_field.type) {
        case ECustomFieldType.STRING:
        case ECustomFieldType.DROPDOWN:
          return String(field.value_string);
        case ECustomFieldType.DATE:
          if (formatDate) {
            const date = new Date(field.value_date);

            return this.datePipe.transform(date, 'MMM dd, yyyy');
          } else {
            return field.value_date;
          }

        case ECustomFieldType.NUMBER:
          return field.value_number;
      }
    }

    return '';
  }
}
